
	import Vue from "vue";

	import TaxLookup from "../components/TaxLookup.vue";
	import TaxesMarketValueSearch from "../components/TaxesMarketValueSearch.vue";

	export default Vue.extend({
		name: "CalculateYourTaxes",

		props: ["disclaimer", "note"],

		data() {
			return {
				isLoading: true,
				activeTab: "tax-info" as string,
			};
		},
		components: {
			TaxLookup,
			TaxesMarketValueSearch,
		},
	});
